import { AuthService, User } from '@skinsoft/auth';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Component } from 'vue-property-decorator';

@Component({
    template: require('./firewall.html'),
})
export class Firewall extends ReactiveVue {
    public $authService: AuthService;
    public user: User | null = null as any;

    public created() {
        this.subscribeTo(this.$authService.user$, (user: User | null) => {
            this.user = user;
        });
    }

    public authorized() {
        return !!this.user;
    }
}
